<h2 mat-dialog-title [innerHTML]="dialogData.title"></h2>
@if (dialogData.scroll) {
  <div mat-dialog-content class="dialog-content-scroll" [innerHTML]="dialogData.content"></div>
}
@if (!dialogData.scroll) {
  <div mat-dialog-content>
    <div class="info-block" [innerHTML]="dialogData.content"></div>
  </div>
}
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close i18n>Close</button>
</mat-dialog-actions>
